import { Page, Text, View, Document, Image } from "@react-pdf/renderer";
import { Font, StyleSheet } from "@react-pdf/renderer";
import { handleArabicPunctuation } from "../../function";

Font.register({
  family: "IBM Plex Sans Arabic",
  src: "/fonts/IBMPlexSansArabic/IBMPlexSansArabic-Regular.ttf",
});
Font.register({
  family: "IBM Plex Sans Arabic Bold",
  src: "/fonts/IBMPlexSansArabic/IBMPlexSansArabic-Bold.ttf",
});

export const Styles = StyleSheet.create({
  portraitPage: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: "9px",
    padding: "57px 17px",
    flexDirection: "row",
    lineHeight: "1.7",
  },
  landscapePage: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: "9px",
    width: "100%",
    flexDirection: "row",
    lineHeight: "1.7",
  },

  arrowIconCont: {
    fontSize: "6px",
    alignItems: "space-between",
  },

  arrowIcon: {
    width: "12px",
    height: "7px",
  },
  curveArrowIcon: {
    width: "20px",
    height: "15px",
  },
  landscapeLeft: {
    flexDirection: "row",
    width: "50%",
    padding: "57px 17px",
  },
  landscapeRight: {
    flexDirection: "row",
    textAlign: "right",
    width: "50%",
    padding: "57px 17px",
  },
  pointingText: {
    marginBottom: "6px",
    fontFamily: "IBM Plex Sans Arabic Bold",
    color: "#FF0000",
  },
  flexRowReverse: {
    flexDirection: "row-reverse",
  },
  flexWrap: {
    flexWrap: "nowrap",
  },
  ml1: {
    marginLeft: "2pt",
  },
});

const MyDocument3 = (props) => {
  let { arabChunks, engChunks } = props;
  const arabicText = (arabicChunks) => {
    return (
      // iterate over the text divided in lines
      arabicChunks?.map((line, idx) => {
        return (
          <View style={[Styles.flexRowReverse, Styles.flexWrap]} key={idx}>
            {
              // divide every line into words and arrange them RTL
              line.map((word, idxWord) => {
                // correct every word for paired punctuation
                return handleArabicPunctuation(word).map(
                  (punctuationWord, punctuationIdx) => {
                    return (
                      <Text style={Styles.ml1} key={punctuationIdx}>
                        {punctuationWord}
                      </Text>
                    );
                  }
                );
              })
            }
          </View>
        );
      })
    );
  };
  return (
    <Document>
      <Page size="A5" style={Styles.portraitPage}>
        <View style={{ width: "40px" }}></View>
        <View style={{ width: "100%" }}>
          <View style={{ height: "100%", textAlign: "right" }}>
            <View
              style={[
                // Styles.flexRowReverse,
                // Styles.flexWrap,
                {
                  height: "481px",
                  overflow: "hidden",
                  // lineHeight: "1.7px"
                },
              ]}
            >
              {arabicText(arabChunks[0])}
            </View>
          </View>
        </View>
        <View style={{ width: "40px", marginLeft: "6px", color: "#FF0000" }}>
          <View style={{ fontSize: "6px", marginTop: "-14px" }}>
            <Text style={Styles.pointingText}>بداية النص</Text>
            <Image
              src="/images/leftpdf_arrow.png"
              style={Styles.arrowIcon}
            ></Image>
          </View>
        </View>
      </Page>

      <Page size="A4" style={Styles.landscapePage} orientation="landscape">
        <View style={Styles.landscapeLeft}>
          <View
            style={{ width: "40px", marginRight: "6px", color: "#FF0000" }}
          ></View>
          <View style={{ width: "80%", textAlign: "right" }}>
            <View
              style={[
                {
                  height: "474px",
                  overflow: "hidden",
                },
              ]}
            >
              {arabicText(arabChunks[2])}
            </View>
          </View>
          <View style={{ width: "40px" }}>
            <View style={{ marginLeft: "6px" }}>
              <Image
                src="/images/leftpdf_arrow.png"
                style={Styles.arrowIcon}
              ></Image>
            </View>
          </View>
        </View>
        <View style={Styles.landscapeRight}>
          <View style={{ width: "40px" }}></View>
          <View style={{ width: "80%", textAlign: "right" }}>
            <View
              style={[
                {
                  height: "474px",
                  overflow: "hidden",
                },
              ]}
            >
              {arabicText(arabChunks[1])}
            </View>
          </View>
          <View style={{ width: "40px", marginLeft: "6px" }}>
            <View style={{ marginTop: "-6px" }}>
              <Image
                src="/images/leftpdf_arrow.png"
                style={Styles.arrowIcon}
              ></Image>
            </View>
          </View>
        </View>
      </Page>

      <Page size="A4" style={Styles.landscapePage} orientation="landscape">
        <View style={Styles.landscapeLeft}>
          <View style={{ width: "40px", marginRight: "6px", color: "#FF0000" }}>
            <View style={Styles.arrowIconCont}>
              <Text style={[Styles.pointingText, { marginTop: "-13px" }]}>
                Start of text
              </Text>
              <Image
                src="/images/rightpdf_arrow.png"
                style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
              ></Image>
            </View>
          </View>
          <View style={{ width: "80%", textAlign: "left" }}>
            <View
              style={{
                height: "481px",
                overflow: "hidden",
              }}
            >
              {engChunks[0]?.map((word, idx) => {
                return <Text key={idx}>{word}</Text>;
              })}
            </View>
          </View>
          <View style={{ width: "40px" }}>
            <View style={{ marginLeft: "6px" }}></View>
          </View>
        </View>
        <View style={Styles.landscapeRight}>
          <View style={{ width: "40px" }}>
            <View style={{ fontSize: "6px", position: "absolute", top: "96%" }}>
              <Text style={Styles.pointingText}>نهاية النص</Text>
              <Image
                src="/images/rightpdf_arrow.png"
                style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
              ></Image>
            </View>
          </View>
          <View style={{ width: "80%", textAlign: "right" }}>
            <View
              style={[
                {
                  height: "481px",
                  overflow: "hidden",
                },
              ]}
            >
              {arabicText(arabChunks[3])}
            </View>
          </View>
          <View style={{ width: "40px", marginLeft: "6px" }}></View>
        </View>
      </Page>

      <Page size="A4" style={Styles.landscapePage} orientation="landscape">
        <View style={Styles.landscapeLeft}>
          <View style={{ width: "40px", marginRight: "6px", color: "#FF0000" }}>
            <View style={Styles.arrowIconCont}>
              <Image
                src="/images/rightpdf_arrow.png"
                style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
              ></Image>
            </View>
          </View>
          <View style={{ width: "80%", textAlign: "left" }}>
            <View
              style={{
                height: "481px",
                overflow: "hidden",
              }}
            >
              {engChunks[2]?.map((word, idx) => {
                return <Text key={idx}>{word}</Text>;
              })}
            </View>
          </View>
          <View style={{ width: "40px" }}>
            <View style={{ marginLeft: "6px" }}></View>
          </View>
        </View>
        <View style={Styles.landscapeRight}>
          <View style={{ width: "40px" }}>
            <View style={{ marginRight: "6px", marginTop: "-4px" }}>
              <Image
                src="/images/rightcurvepdf_arrow.png"
                style={[Styles.curveArrowIcon, { alignSelf: "flex-end" }]}
              ></Image>
            </View>
          </View>
          <View style={{ width: "80%", textAlign: "left" }}>
            <View
              style={{
                height: "481px",
                overflow: "hidden",
              }}
            >
              {engChunks[1]?.map((word, idx) => {
                return <Text key={idx}>{word}</Text>;
              })}
            </View>
          </View>
          <View style={{ width: "40px", marginLeft: "6px" }}></View>
        </View>
      </Page>

      <Page size="A5" style={Styles.portraitPage}>
        <View style={{ width: "40px", marginRight: "6px" }}>
          <View>
            <Image
              src="/images/rightpdf_arrow.png"
              style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
            ></Image>
          </View>
        </View>
        <View style={{ width: "100%" }}>
          <View
            style={{
              height: "481px",
              overflow: "hidden",
            }}
          >
            {engChunks[3]?.map((word, idx) => {
              return <Text key={idx}>{word}</Text>;
            })}
          </View>
        </View>
        <View style={{ width: "40px", marginLeft: "6px", color: "#FF0000" }}>
          <View style={{ fontSize: "6px", position: "absolute", top: "98%" }}>
            <Text style={Styles.pointingText}>End of text</Text>
            <Image
              src="/images/leftpdf_arrow.png"
              style={Styles.arrowIcon}
            ></Image>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default MyDocument3;
